import { interactiveServiceFetch } from '../services/interactiveServiceFetch';
import { CONNECTIONS_PATHS } from './constants';

export class ConnectionsApiError extends Error {
    constructor(status) {
        super(`Connections API error ${status}`);
        this.name = 'ConnectionsApiError';
        this.status = status;
    }
}

const request = async (url, options) => {
    const response = await interactiveServiceFetch(url, options);
    if (!response.ok) throw new ConnectionsApiError(response.status);
    if (response.status === 204) return null;
    return response.json();
};

const withAdminMode = (path, adminMode) => `${path}?${new URLSearchParams({ admin_mode: Boolean(adminMode) })}`;

export const fetchConnections = adminMode => request(withAdminMode(CONNECTIONS_PATHS.LIST, adminMode));

export const startConnection = (connectionId, adminMode) =>
    request(withAdminMode(CONNECTIONS_PATHS.start(connectionId), adminMode), { method: 'POST' });

export const disconnectConnection = connectionId =>
    request(CONNECTIONS_PATHS.connection(connectionId), { method: 'DELETE' });
